import { ToastAlertTypes } from '@genial/components';

export const searchPlaceholder = 'Pesquise por ID';

export const successRateManagementSentMessage: [ToastAlertTypes.Type, string, string] = [
  'success',
  'Tudo certo!',
  'Sua solicitação foi enviada com sucesso!',
];
